import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const meaDamApi = createApi({
    reducerPath: "core/measurement/dam",
    baseQuery: axiosBaseQuery,
    tagTypes: ["measurementDamList"],
    endpoints: (builder) =>({
        measurementDamFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['measurementDamList'],
            query: (query = '') => ({
                url: "core/measurement/dam" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        measurementDamCreate: builder.mutation({
            invalidatesTags: ['measurementDamList'],
            query: (data)=>({url: "core/measurement/dam", method: "POST", data})
        }),
        measurementDamUpdate: builder.mutation({
            invalidatesTags: ['measurementDamList'],
            query: (data)=>({url: "/core/measurement/dam/"+data.id, method: "PUT", data})
        }),
        measurementDamDelete: builder.mutation({
            invalidatesTags: ['measurementDamList'],
            query: (id)=>({url: "/core/measurement/dam/"+id, method: "DELETE"})
        }),
    })
})

export const { useMeasurementDamFindAllQuery, useMeasurementDamCreateMutation, useMeasurementDamUpdateMutation, useMeasurementDamDeleteMutation } = meaDamApi;
export {meaDamApi};
